import React, {useEffect} from 'react';
import styled from "styled-components";
import {CaptionListProps} from "../../../types/caption";
import {useAtom} from "jotai";
import {playerState} from "../../../states/player";
import {timestamp2seconds} from "../../../helper/helper";
import {captionItemState, captionListState} from "../../../states/caption";

type CaptionInfoInnerProps = {
  captionData: CaptionListProps
}

/**
 자막 정보 (넘버링)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function CaptionInfoInner({captionData}: CaptionInfoInnerProps) {

  const [captionList] = useAtom(captionListState);
  const [{playOn}, setPlayer] = useAtom(playerState);
  const [{currentCaptionId, intervalCaptionOn, intervalCaptionId, intervalCaptionSelectedIds}, setCaptionItem] = useAtom(captionItemState)

  const intervalCaptionSelectedHandler = (seq:number) => {

    const existIntervalCaptionSelectedIds = intervalCaptionSelectedIds.findIndex((v)=> v === seq)

    if (existIntervalCaptionSelectedIds > -1) {

      const updateIntervalCaptionSelectedIds = [...intervalCaptionSelectedIds];
      updateIntervalCaptionSelectedIds.splice(existIntervalCaptionSelectedIds, 1);
      updateIntervalCaptionSelectedIds.sort((a,b)=> a - b ); // 오름차순
      setCaptionItem((prev) => ({
        ...prev,
        intervalCaptionSelectedIds:updateIntervalCaptionSelectedIds
      }))
    } else {

      const addIntervalCaptionSelectedIds = [...intervalCaptionSelectedIds,seq].sort((a,b)=>a-b);

      setCaptionItem((prev) => ({
        ...prev,
        intervalCaptionSelectedIds:addIntervalCaptionSelectedIds
      }))



    }

  }





  const existCheckIntervalCaptionSelectedIds = (seq:number) => {
    const existIntervalCaptionSelectedIds = intervalCaptionSelectedIds.findIndex((v)=> v === seq)

    return existIntervalCaptionSelectedIds > -1 ? true : false
  }

  const setIntervalCaptionStartEndTime = () => {




  }


  return (
    <InnerArea>
      <div className="number_area">{captionData.seq}</div>
      <div className="video_btn_area">
        <button
          type="button"
          className="btn"
          title="이 자막에 해당하는 부분 재생"
          onClick={() => {
            setPlayer((prev) => ({
              ...prev,
              playOn: !playOn,
              seekOnTime: timestamp2seconds(captionData.time_ini),
              currentTime: timestamp2seconds(captionData.time_ini)
            }))
          }}
        >
          <i className={"bi " + (captionData.seq == currentCaptionId && playOn ? "bi-pause-fill" : "bi-play-fill")}></i>
          <span className="hide">이 자막에 해당하는 부분 재생</span>
        </button>

        <button
          type="button"
          className={"btn btn-repeat " + (captionData.seq == intervalCaptionId && intervalCaptionOn ? "active" : "")}
          title="이 자막에 해당하는 부분 반복"
          onClick={() => {

            setCaptionItem((prev) => ({
              ...prev,
              intervalCaptionSelectedIds:[],
              intervalCaptionOn: captionData.seq == intervalCaptionId ? !intervalCaptionOn : true,
              intervalCaptionId: captionData.seq
            }))

            setPlayer((prev) => ({
              ...prev,
              intervalStartTime: captionData.time_ini,
              intervalEndTime: captionData.time_end
            }))

          }}
        >
          <i className="bi bi-repeat"></i>
          <span className="hide">이 자막에 해당하는 부분 반복</span>
        </button>

        <button
          type="button"
          className={"btn btn-repeat-select " + (existCheckIntervalCaptionSelectedIds(captionData.seq) ? "active" : "") }
          title="반복 범위 선택"
          onClick={() => {
            intervalCaptionSelectedHandler(captionData.seq);
          }}
        >
          <i className="bi bi-check-circle"></i>
          <span className="hide">이 자막에 해당하는 부분 반복</span>
        </button>
      </div>
    </InnerArea>
  );
}


const InnerArea = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;


  .number_area {
    font-size: 25px;
    font-weight: bold;
    line-height: 1.5;
    width: 35px;
  }

  .video_btn_area {
    .btn {
      width: 24px;
      height: 24px;
      margin-left: 10px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      font-size: 20px;
      line-height: 1;
      -webkit-transition: background-color 0.1s;
      -o-transition: background-color 0.1s;
      -moz-transition: background-color 0.1s;
      transition: background-color 0.1s;
      opacity: 0.5;

      .bi {
        margin-left: 2px;
      }

      &.active {
        color: #0a87ff;
        opacity: 1.0;
      }

      &:hover {
        color: #0a87ff;
        opacity: 1.0;
      }

      &.btn-repeat {
        margin-left: 0px;
        font-size: 16px;
      }

      &.btn-repeat-select {
        margin-left: 0px;
        font-size: 16px;
      }
    }
  }
`;
